import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { SelectChangeEvent, SxProps } from "@mui/material";
import type { Theme } from "@emotion/react";

type Props = {
  value: string;
  menuList: string[];
  label: string;
  sx?: SxProps<Theme> | undefined;
  onChange: ((event: SelectChangeEvent<string>, child: React.ReactNode) => void) | undefined;
  name?: string;
}

const SelectedMui = ({ label, menuList, value, onChange, name, sx }: Props) => {

  return (
    <FormControl fullWidth sx={sx}>
    <InputLabel id="selected-mui">{label}</InputLabel>
    <Select
      labelId="selected-mui"
      name={name}
      value={value}
      label={label}
      onChange={onChange}
    >
      {menuList.map(menu => 
      <MenuItem key={menu} value={menu}>{menu}</MenuItem>
      )}
    </Select>
  </FormControl>
  );
};

export { SelectedMui };